import styled from "styled-components";

export const Message = styled.p`
  text-align: center;
  font-family: "Iosevka Charon", monospace;
  font-size: 18px;
`;
